export default "__VITE_ASSET__CRTS0HXV__"